import { useUser } from '@/context/userContext';
import { isAcceptedMasterServiceAgreement } from '@/helpers/userHelpers';
import { Navigate, Outlet } from 'react-router';
import { getSelectBillingPlanPath } from '../SelectBillingPlanPage/path';
import { isEnterprisePlanType } from '@/helpers/billingHelpers';

export const AcceptMasterServiceAgreementProtectedRoute = () => {
  const { user } = useUser();
  const isAcceptedAgreement = isAcceptedMasterServiceAgreement(user);
  const isEnterprisePlan = isEnterprisePlanType(user);

  if (isAcceptedAgreement || isEnterprisePlan) {
    return <Navigate to={getSelectBillingPlanPath()} replace />;
  }

  return <Outlet />;
};
